import axios, { AxiosRequestConfig } from "axios";
import { mapDataToQuoteRequest } from "@/utils/quote";
import { useConfigStore } from "@/stores/config";
import { useQuoteStore } from "@/stores/quotes";
import { validateQuoteResponse } from "@/entities/quote";
import { z } from "zod";
import { getSessionId } from "@/utils";

export const runQuote = async (quoteNumber: string | undefined) => {
    const { url, body, axiosConfig } = await getQuoteRequestData(quoteNumber);

    const response = await axios.post(url, body, axiosConfig);
    const result = validateQuoteResponse.parse(response.data);

    return processQuoteResponse(result);
};

async function getQuoteRequestData(quoteNumber: string | undefined) {
    const quoteStore = useQuoteStore();
    const config = useConfigStore();
    const body = mapDataToQuoteRequest();
    const axiosConfig: AxiosRequestConfig = {};
    let url = `${config.apiUrl}/v1/annuities/quote`;

    body.initiatorId = quoteStore.quote?.initiatorId;
    body.agencyNumber = quoteStore.quote?.agencyNumber;
    body.appointmentChoice = quoteStore.quote?.appointmentChoice ?? null;

    body.affiliate = quoteStore.getAffiliate();

    const maybeQuoteNumberToken = getQuoteNumberToken(quoteNumber);

    if (maybeQuoteNumberToken) {
        axiosConfig.headers = { authorization: maybeQuoteNumberToken.token };
        url = `${config.apiUrl}/v1/annuities/requote/${maybeQuoteNumberToken.quoteNumber}`;
    }

    url = `${url}?sessionId=${getSessionId()}`;

    return { quoteStore, url, body, axiosConfig };
}

async function processQuoteResponse(
    result: z.infer<typeof validateQuoteResponse>,
) {
    const quoteStore = useQuoteStore();
    quoteStore.setToken(result.response.quoteNumber, result.response.token);

    if (result.response.panel) {
        quoteStore.quotations = [];
        quoteStore.panelSize = result.response.panel.size;
    }
    return result.response;
}

function getQuoteNumberToken(quoteNumber: string | undefined): { quoteNumber: string, token: string} | null {
    const quoteStore = useQuoteStore();

    if (!quoteNumber) {
        return null;
    }

    try {
        return quoteStore.latestTokenByQuoteNumber(quoteNumber);
    } catch (e) {
        return null;
    }
}
